import { render, staticRenderFns } from "./OpportunitiesQualityControlCampaigns.vue?vue&type=template&id=1675837f&scoped=true"
import script from "./OpportunitiesQualityControlCampaigns.vue?vue&type=script&lang=js"
export * from "./OpportunitiesQualityControlCampaigns.vue?vue&type=script&lang=js"
import style0 from "./OpportunitiesQualityControlCampaigns.vue?vue&type=style&index=0&id=1675837f&prod&scoped=true&lang=css"
import style1 from "./OpportunitiesQualityControlCampaigns.vue?vue&type=style&index=1&id=1675837f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1675837f",
  null
  
)

export default component.exports